import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckCircle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckCircle2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.4727 13.9336L8 11.4609L6.58594 12.875L10.7764 17.0654L16.3877 8.72852L14.7285 7.6123L10.4727 13.9336Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckCircle2;
